import * as yup from 'yup';
import {
  accountRegex,
  emailRegex,
  gstRegex,
  ifscRegex,
  panRegex,
  phoneRegex,
  pincodeRegex,
} from '../../constants';

export const schema = yup
  .object()
  .shape({
    firmName: yup.string().required('Vendor name is required.'),
    mobileNumber: yup
      .string()
      .required('Vendor mobile number is Required')
      .matches(phoneRegex, 'Phone number is not valid'),
    emailId: yup
      .string()
      .required('Vendor email is required.')
      .matches(emailRegex, 'Invalid email'),
    ownerName: yup.string().required('Director name is a required field.'),
    contactPersonName: yup.string().required('Manager name is a required field.'),
    address: yup.string().required('Address is required field.'),
    pincode: yup
      .string()
      .required('Pincode is required.')
      .matches(pincodeRegex, 'Invalid pincode.'),
    city: yup.string().required('City is a required.'),
    state: yup.string().required('State is a required.'),
    pan: yup.string().required('PAN number is required.').matches(panRegex, 'Invalid pan number.'),
    gst: yup.string().required('GST is required.').matches(gstRegex, 'Invalid GST number'),
    bankAccountNumber: yup
      .string()
      .required('Account number is required.')
      .matches(accountRegex, 'Invalid account number.'),
    ifsc: yup.string().required('IFSC is required.').matches(ifscRegex, 'Invalid IFSC code'),
  })
  .required();
